import React, { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import axios from "axios";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Assets } from "../../../../../../assets/Assets";
import { RpmOtherDetailsGridLayout } from "./RpmOtherDetailsGridLayout";
import "./rpmprofile.css";
import { RpmProfileReportsRowLayout } from "./RpmProfileReportsRowLayout";
import {
  fetch_patient_profile_details,
  updateprofileinfo,
  getpatientvitals,
  AcceptorRejectpackage,
} from "../../../../../../actions/RPMAction";
import Spinner from "react-bootstrap/Spinner";
import {
  EditIcon,
  EditRpmIcon,
  RpmStatusTriangle,
  ArrowLeft,
} from "../../../../../../assets/Logos/Icons";
import {
  Marriagestatus,
  gender,
  occupation,
  relationship,
  Insuranceproviders,
  bloodGroups,
} from "../../../../Constants/Menus/ConstantMenus";
import { DatePicker, Input, Modal, Form, Radio, Button } from "antd";
import SuccessModal from "../../../Modals/SuccessModel/SuccessModal";
import Dropdown from "../../../DropDown/Dropdown";
import CustomPhoneInputV2 from "../../../../../CustomPhoneInputV2/CustomPhoneInputV2";
import PatientLatestVitals from "../../../Other Components/PatientLatestVitals";
const { TextArea } = Input;

function RpmProfile({ white }) {
  let [isEditOpen, setEditOpen] = useState(false);
  let [accessCountry, setAccessCountry] = useState("");
  let [isrejectOpen, setisrejectOpen] = useState(false);
  let [isacceptOpen, setisacceptOpen] = useState(false);
  let [successMessage, setSuccessMessage] = useState("");

  let [rejectionreason, setrejectionreason] = useState("");

  let [isstatuschange, setisstatuschange] = useState(false);
  let [status, setstatus] = useState("");

  let [editItem, setEditItem] = useState(null);
  let [updatedData, setUpdatedData] = useState();
  let [updatedDatas, setUpdatedDatas] = useState([]);

  let [packageDetails, setPackageDetails] = useState([]);

  let editOptions = [
    "Personal Info",
    "Regular Doctor",
    "Emergency Contact",
    "Insurance",
    "profile",
  ];

  let dummyUserImage =
    "https://cdn.gobankingrates.com/wp-content/uploads/2020/07/Jeff-Bezos-shutterstock_1399561367.jpg";
  let reduxData = useSelector((state) => state);
  //  let patientDetails ="";
  // let patientDetails = reduxData.rpmreducer.fetchPatientProfile &&        reduxData.rpmreducer.fetchPatientProfile.data;
  const location = useLocation();
  let dispatch = useDispatch();
  let patientId = ""; //**** IMPORTANT: Pass the patient Id */
  let nurseId = ""; //**** IMPORTANT: Pass the nurse Id*/
  patientId = location.state?.patientId;
  // signupData = location.state?.detail;
  console.log(reduxData);
  let patientDetails =
    reduxData.rpmreducer.fetchPatientProfile &&
    reduxData.rpmreducer.fetchPatientProfile.data;
  const userData = JSON.parse(localStorage.getItem("userData"));

  let userType = reduxData.login.user.userType;

  patientId = userData.profileId;
  let messagenodata = "NA";
  let repots = [];

  const [profileform] = Form.useForm();
  let reasonforrejection = ["No Need package", "No valid package"];

  let [formData, setFormData] = useState({
    EmergencyContactaddress1: "",
    EmergencyContactaddress2: "",
    EmergencyContactalternativephoneNumber: "",
    EmergencyContactcity: "",

    EmergencyContactcountry: "",

    EmergencyContactlandmark: "",

    EmergencyContactname: "",
    EmergencyContactphoneNumber: "",
    EmergencyContactPIN: "",

    EmergencyContactrelationship: "",
    EmergencyContactstate: "",
    InsuranceExpiryDate: "",
    InsuranceCompany: "",
    InsuranceMemberNumber: "",
    RegularDoctorphoneNumber: "",
    RegularDoctorname: "",
    RegularDoctorpracticeName: "",

    Informationaddress1: "",
    Informationaddress2: "",
    Informationage: "",
    Informationbloodgroup: "",
    Informationcity: "",
    Informationcountry: "",
    Informationdob: "",
    Informationemailid: "",
    Informationfullname: "",
    Informationgender: "",
    Informationheight: "",
    InformationheightValue: "",
    Informationlandmark: "",

    Informationmaritalstatus: "",
    InformationnationalId: "",
    Informationnationality: "",
    Informationoccupation: "",
    Informationmobilenumber: "",
    InformationPIN: "",
    InformationprofileImage: "",
    Informationsincefrom: "",
    Informationstate: "",
    Informationweight: "",
    InformationweightValue: "",
    packagerejectreason: "",
  });

  useEffect(() => {
    console.log("Calling fetch_patient_profile_details...........");
    dispatch(fetch_patient_profile_details(patientId, nurseId, 0)).then(
      (res) => {
        console.log(
          "fetch_patient_profile_details appointment history...........",
          res
        );
      }
    );
  }, []);

  useEffect(() => {
    try {
      dispatch(fetch_patient_profile_details(patientId, nurseId)).then(
        (res) => {
          console.log("book_slot API result ==> ", res);
          if (res.info == "Data failed to update") {
          } else {
            let patientDetailss = res.data;
            patientDetails = res.data;
            console.log(res.data.packageinfo);
            if (
              res.data.packageinfo != undefined &&
              res.data.packageinfo != null
            ) {
              packageDetails = res.data.packageinfo;
              setPackageDetails(res.data.packageinfo);
              setstatus(res.data.packageinfo.status);
            }

            setFormData({
              EmergencyContactaddress1:
                patientDetailss.EmergencyContact?.address1,
              EmergencyContactaddress2:
                patientDetailss.EmergencyContact?.address2,
              EmergencyContactalternativephoneNumber:
                patientDetailss.EmergencyContact?.alternativephoneNumber,
              EmergencyContactcity: patientDetailss.EmergencyContact?.city,
              EmergencyContactcountry:
                patientDetailss.EmergencyContact?.country,
              EmergencyContactlandmark:
                patientDetailss.EmergencyContact?.landmark,
              EmergencyContactname: patientDetailss.EmergencyContact?.name,
              EmergencyContactphoneNumber:
                patientDetailss.EmergencyContact?.phoneNumber,
              EmergencyContactPIN: patientDetailss.EmergencyContact?.PIN,
              EmergencyContactrelationship:
                patientDetailss.EmergencyContact?.relationship,
              EmergencyContactstate: patientDetailss.EmergencyContact?.state,
              InsuranceExpiryDate: patientDetails.Insurance?.ExpiryDate,
              InsuranceCompany: patientDetails.Insurance?.Company,
              InsuranceMemberNumber: patientDetails.Insurance?.MemberNumber,
              Informationaddress1: patientDetails.Information?.address1,
              Informationaddress2: patientDetails.Information?.address2,
              Informationage: patientDetails.Information?.age,
              Informationbloodgroup: patientDetails.Information?.bloodgroup,
              Informationcity: patientDetails.Information?.city,
              Informationcountry: patientDetails.Information?.country,
              Informationdob: patientDetailss.Information?.dob,
              Informationemailid: patientDetails.Information?.emailid,
              Informationfullname: patientDetails.Information?.fullname,
              Informationgender: patientDetails.Information?.gender,
              Informationheight:
                patientDetails.Information?.heightValue != null
                  ? patientDetails.Information?.heightValue.replace(" cm", "")
                  : "",
              InformationheightValue:
                patientDetails.Information?.heightValue != null
                  ? patientDetails.Information?.heightValue.replace(" cm", "")
                  : "",
              Informationlandmark: patientDetails.Information?.landmark,
              Informationmaritalstatus:
                patientDetails.Information?.maritalstatus,
              InformationnationalId: patientDetails.Information?.nationalId,
              Informationnationality: patientDetails.Information?.nationality,
              Informationoccupation: patientDetails.Information?.occupation,
              Informationmobilenumber: patientDetails.Information?.mobilenumber,
              InformationPIN: patientDetails.Information?.PIN,
              InformationprofileImage: patientDetails.Information?.profileImage,
              Informationsincefrom: patientDetails.Information?.sincefrom,
              Informationstate: patientDetails.Information?.state,
              Informationweight:
                patientDetails.Information?.weightValue != null
                  ? patientDetails.Information?.weightValue.replace(" kg", "")
                  : "",
              InformationweightValue:
                patientDetails.Information?.weightValue != null
                  ? patientDetails.Information?.weightValue.replace(" kg", "")
                  : "",
              RegularDoctorphoneNumber:
                patientDetails.RegularDoctor?.phoneNumber,
              RegularDoctorname: patientDetails.RegularDoctor?.name,
              RegularDoctorpracticeName:
                patientDetails.RegularDoctor?.practiceName,
            });
          }
          // setPaymentLoading(false)
          // console.log("book_slot API result ==> ", res);
        }
      );

      // setUpdatedDatas(patientDetails.Information)
    } catch (error) {
      console.log("Error in fetch_clinic_speciality API", error);
    }
  }, [updatedDatas]);

  let handleEditClick = (item, itemType, defaultValue) => {
    if (item && itemType) {
      setEditItem({ item, itemType, defaultValue });
      setEditOpen(!isEditOpen);
    }
  };

  let allowOnlyunumber = (e) => {
    if (e.target.value.includes(".") && e.key == ".") {
      e.preventDefault();
    }

    ![
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ".",
      "Backspace",
    ].includes(e.key) && e.preventDefault();
  };

  let handleEditOk = () => {
    //console.log("Only changed Items will store in state and log here ==> ", updatedData);
    // console.log("Only changed Items will store in state and log here ==> ", formData);
    setEditOpen(false);
    let requestdata = {
      patientId: patientId,
      EmergencyContact: {
        address1: formData.EmergencyContactaddress1,
        address2: formData.EmergencyContactaddress2,
        alternativephoneNumber:
          formData.EmergencyContactalternativephoneNumber != null &&
          formData.EmergencyContactalternativephoneNumber.length > 5
            ? formData.EmergencyContactalternativephoneNumber.includes("+")
              ? formData.EmergencyContactalternativephoneNumber.replace(
                  "+",
                  "%2B"
                )
              : "%2B" + formData.EmergencyContactalternativephoneNumber
            : "",
        city: formData.EmergencyContactcity,
        cityError: true,
        country: formData.EmergencyContactcountry,
        countryError: true,
        landmark: formData.EmergencyContactlandmark,
        landmarkError: true,
        name: formData.EmergencyContactname,
        phoneNumber:
          formData.EmergencyContactphoneNumber != null &&
          formData.EmergencyContactphoneNumber.length > 3
            ? formData.EmergencyContactphoneNumber.includes("+")
              ? formData.EmergencyContactphoneNumber.replace("+", "%2B")
              : "%2B" + formData.EmergencyContactphoneNumber
            : "",
        PIN: formData.EmergencyContactPIN,
        pinError: true,
        relationship: formData.EmergencyContactrelationship,
        state: formData.EmergencyContactstate,
        stateError: true,
      },
      Insurance: {
        ExpiryDate: formData.InsuranceExpiryDate,
        Company: formData.InsuranceCompany,
        MemberNumber: formData.InsuranceMemberNumber,
      },

      Information: {
        address1: formData.Informationaddress1,
        address2: formData.Informationaddress2,

        bloodgroup:
          formData.Informationbloodgroup != null
            ? formData.Informationbloodgroup.includes("+")
              ? formData.Informationbloodgroup.replace("+", "%2B")
              : formData.Informationbloodgroup.replace("-", "%2D")
            : null,
        city: formData.Informationcity,
        country: formData.Informationcountry,
        dob: formData.Informationdob,
        emailid: formData.emailid,
        fullname: formData.Informationfullname,
        gender: formData.Informationgender,
        height: formData.InformationheightValue
        ? formData.InformationheightValue + " cm"
        : "",
      heightValue: formData.InformationheightValue
        ? formData.InformationheightValue + " cm"
        : "",
   landmark: formData.Informationlandmark,
        emailid: formData.Informationemailid,
        maritalstatus: formData.Informationmaritalstatus,
        nationalId: formData.InformationnationalId,
        nationality: formData.Informationnationality,
        occupation: formData.Informationoccupation,
        mobilenumber:
          formData.Informationmobilenumber != null
            ? formData.Informationmobilenumber.includes("+")
              ? formData.Informationmobilenumber.replace("+", "%2B")
              : "%2B" + formData.Informationmobilenumber
            : "",
        PIN: formData.InformationPIN,

        state: formData.Informationstate,
        weight: formData.InformationweightValue
        ? formData.InformationweightValue + " kg"
        : "",
      weightValue: formData.InformationweightValue
        ? formData.InformationweightValue + " kg"
        : "",
           },
      RegularDoctor: {
        phoneNumber:
          formData.RegularDoctorphoneNumber != null
            ? formData.RegularDoctorphoneNumber.includes("+")
              ? formData.RegularDoctorphoneNumber.replace("+", "%2B")
              : "%2B" + formData.RegularDoctorphoneNumber
            : "",
        name: formData.RegularDoctorname,
        practiceName: formData.RegularDoctorpracticeName,
      },
    };

    //console.log("saved items ==> ", requestdata);
    dispatch(updateprofileinfo(requestdata)).then((res) => {
      //console.log("res items ==> ", res);
      if (res.data.info != "Patient profile updated successfully") {
      } else {
        dispatch(fetch_patient_profile_details(patientId, nurseId)).then(
          (res) => {
            // console.log("book_slot API result ==> ", res);
            if (res.info == "Data failed to update") {
            } else {
              let patientDetailss = res.data;
              patientDetails = res.data;
              setFormData({
                EmergencyContactaddress1:
                  patientDetailss.EmergencyContact?.address1,
                EmergencyContactaddress2:
                  patientDetailss.EmergencyContact?.address2,
                EmergencyContactalternativephoneNumber:
                  patientDetailss.EmergencyContact?.alternativephoneNumber,
                EmergencyContactcity: patientDetailss.EmergencyContact?.city,
                EmergencyContactcountry:
                  patientDetailss.EmergencyContact?.country,
                EmergencyContactlandmark:
                  patientDetailss.EmergencyContact?.landmark,
                EmergencyContactname: patientDetailss.EmergencyContact?.name,
                EmergencyContactphoneNumber:
                  patientDetailss.EmergencyContact?.phoneNumber,
                EmergencyContactPIN: patientDetailss.EmergencyContact?.PIN,
                EmergencyContactrelationship:
                  patientDetailss.EmergencyContact?.relationship,
                EmergencyContactstate: patientDetailss.EmergencyContact?.state,
                InsuranceExpiryDate: patientDetails.Insurance?.ExpiryDate,
                InsuranceCompany: patientDetails.Insurance?.Company,
                InsuranceMemberNumber: patientDetails.Insurance?.MemberNumber,
                Informationaddress1: patientDetails.Information?.address1,
                Informationaddress2: patientDetails.Information?.address2,
                Informationage: patientDetails.Information?.age,
                Informationbloodgroup: patientDetails.Information?.bloodgroup,
                Informationcity: patientDetails.Information?.city,
                Informationcountry: patientDetails.Information?.country,
                Informationdob: patientDetailss.Information?.dob,
                Informationemailid: patientDetails.Information?.emailid,
                Informationfullname: patientDetails.Information?.fullname,
                Informationgender: patientDetails.Information?.gender,
                Informationheight:
                  patientDetails.Information?.heightValue != null
                    ? patientDetails.Information?.heightValue.replace(" cm", "")
                    : "",
                InformationheightValue:
                  patientDetails.Information?.heightValue != null
                    ? patientDetails.Information?.heightValue.replace(" cm", "")
                    : "",
                Informationlandmark: patientDetails.Information?.landmark,
                Informationmaritalstatus:
                  patientDetails.Information?.maritalstatus,
                InformationnationalId: patientDetails.Information?.nationalId,
                Informationnationality: patientDetails.Information?.nationality,
                Informationoccupation: patientDetails.Information?.occupation,
                Informationmobilenumber:
                  patientDetails.Information?.mobilenumber,
                InformationPIN: patientDetails.Information?.PIN,
                InformationprofileImage:
                  patientDetails.Information?.profileImage,
                Informationsincefrom: patientDetails.Information?.sincefrom,
                Informationstate: patientDetails.Information?.state,
                Informationweight:
                  patientDetails.Information?.weightValue != null
                    ? patientDetails.Information?.weightValue.replace(" kg", "")
                    : "",
                InformationweightValue:
                  patientDetails.Information?.weightValue != null
                    ? patientDetails.Information?.weightValue.replace(" kg", "")
                    : "",
                RegularDoctorphoneNumber:
                  patientDetails.RegularDoctor?.phoneNumber,
                RegularDoctorname: patientDetails.RegularDoctor?.name,
                RegularDoctorpracticeName:
                  patientDetails.RegularDoctor?.practiceName,
              });
            }
            // setPaymentLoading(false)
            console.log("book_slot API result ==> ", res);
          }
        );
        dispatch(getpatientvitals(patientId));
      }
    });
  };

  let handleEditClose = () => {
    console.log("hiih");
    setEditOpen(false);
    profileform.resetFields();
  };

  let handleEditSelectChange = (value, e) => {
    setUpdatedData({
      ...updatedData,
      [e]: value,
    });
  };

  let handleEditInputChange = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.id]: e.target.value,
    });
  };

  let handleEditInputChanges = ({ key, value }) => {
    console.log({ key, value });
    setFormData({ ...formData, [key]: value });
  };

  let handleEditInputNumberChange = ({ key, value }) => {
    setUpdatedData({
      ...updatedData,
      [key]: `+${value}`,
    });
  };
  let handleEditInputDateChange = ({ key, value }) => {
    setUpdatedData({
      ...updatedData,
      [key]: `${value}`,
    });
  };

  const onFinishVitals = (values) => {};

  const AcceptorRejectsubscription = (type, requestId) => {
    console.log(type, requestId);
    if (type === "Reject") {
      setisrejectOpen(true);
    } else {
      dispatch(
        AcceptorRejectpackage(requestId, type, rejectionreason, userType)
      ).then((res) => {
        if (res?.info.length > 0) {
          console.log(res);
          setisacceptOpen(true);
          setSuccessMessage("Package accepted successfully");
          setstatus("Payment Pending");
          setisstatuschange(true);
        }
      });
    }
  };
  const Rejectsubscription = (type, requestId) => {
    console.log(type, requestId, rejectionreason);
    dispatch(
      AcceptorRejectpackage(requestId, type, rejectionreason, userType)
    ).then((res) => {
      console.log(res);
      setisrejectOpen(false);
      setisacceptOpen(true);
      setSuccessMessage("Package accepted successfully");
      setstatus("Rejected by" + userType);
      setisstatuschange(true);
    });
  };

  let handlerectClose = () => {
    setrejectionreason("");
    setisrejectOpen(false);
  };

  const onFinishFailedVitals = (error) => {
    console.log(error);
  };
  let vitalsdata = "";
  // let vitalsdata =
  // reduxData.rpmreducer.patientsvital!=undefined &&
  // reduxData.rpmreducer.patientsvital.data[0];
  let getDataFromVitals = (itemName, extension, ifEmpty) => {
    if (vitalsdata && vitalsdata[itemName]) {
      if (extension) {
        return vitalsdata[itemName] + extension;
      } else {
        return vitalsdata[itemName];
      }
    } else if (ifEmpty) {
      return "NA";
    } else {
      return "";
    }
  };

  let classNames = {
    Normal: { tile: "normaltile" },
    Abnormal: { tile: "abnormaltile" },
    Critical: { tile: "criticaltile" },
  };

  useEffect(() => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        let data = response.data;
        console.log(data);

        setAccessCountry(data.country);
        //  setCounty(data.country_name)
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  var bmi =
    ((patientDetails?.Information?.weightValue != undefined &&
      patientDetails?.Information?.weightValue.split(" ")[0]) /
      (patientDetails?.Information?.heightValue != undefined
        ? patientDetails?.Information?.heightValue.split(" ")[0] *
          patientDetails?.Information?.heightValue.split(" ")[0]
        : "")) *
    10000;
  //var bmi = "";

  let address = patientDetails?.Information?.address1
    ? patientDetails?.Information?.address1
    : "";
  address +=
    patientDetails?.Information?.address2 != ""
      ? ", " + patientDetails?.Information?.address2
      : "";
  address +=
    patientDetails?.Information?.city != undefined
      ? ", " + patientDetails?.Information?.city
      : "";
  address +=
    patientDetails?.Information?.landmark != ""
      ? ", " + patientDetails?.Information?.landmark
      : "";
  address +=
    patientDetails?.Information?.state != undefined
      ? ", " + patientDetails?.Information?.state
      : "";
  address +=
    patientDetails?.Information?.country != undefined
      ? ", " + patientDetails?.Information?.country
      : "";
  address +=
    patientDetails?.Information?.PIN != undefined
      ? ", " + patientDetails?.Information?.PIN
      : "";

  //console.log("address =",address)

  let emeraddress = patientDetails?.EmergencyContact?.address1
    ? patientDetails?.EmergencyContact?.address1
    : "";
  emeraddress +=
    patientDetails?.EmergencyContact?.address2 != "" &&
    patientDetails?.EmergencyContact?.address2 != null
      ? ", " + patientDetails?.EmergencyContact?.address2
      : "";
  emeraddress +=
    patientDetails?.EmergencyContact?.city != ""
      ? ", " + patientDetails?.EmergencyContact?.city
      : "";
  emeraddress +=
    patientDetails?.EmergencyContact?.landmark != "" &&
    patientDetails?.EmergencyContact?.landmark != null
      ? ", " + patientDetails?.EmergencyContact?.landmark
      : "";
  emeraddress +=
    patientDetails?.EmergencyContact?.state != ""
      ? ", " + patientDetails?.EmergencyContact?.state
      : "";
  emeraddress +=
    patientDetails?.EmergencyContact?.country != ""
      ? ", " + patientDetails?.EmergencyContact?.country
      : "";
  emeraddress +=
    patientDetails?.EmergencyContact?.PIN != ""
      ? ", " + patientDetails?.EmergencyContact?.PIN
      : "";

  console.log("patientDetails?.Information?",patientDetails?.Information?.mobilenumber?.split(" ")[1])
  return (
    <div className="rpm-profile-container">
      {patientDetails == undefined ? (
        <div className="loader">
          {/* ****IMPORTANT Loader is not working */}
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <>
          <div className="rpm-profile-container_row">
            <div className="profile-main">
              <div className="user-details item-container">
                <img
                  src={
                    patientDetails?.Information?.profileImage
                      ? patientDetails?.Information?.profileImage
                      : "https://www.connect2mydoctor.com/assets/img/doctor-avatar.jpg"
                  }
                  alt="user_image"
                />
                <span className="name">
                  {formData.Informationfullname}
                  <div
                    className="edit-icon-container"
                    onClick={() => {
                      handleEditClick(
                        editOptions[4],
                        "input",
                        patientDetails?.Information?.fullname
                      );
                    }}
                  >
                    <EditRpmIcon />
                  </div>
                </span>
                <span className="age">
                  <b>ID : </b>
                  {patientId}
                </span>
                <span className="age">
                  <b>Age : &nbsp;</b>{" "}
                  {formData.Informationage
                    ? formData.Informationage + " years"
                    : messagenodata}
                </span>
                <span className="age">
                  <b>Gender : &nbsp;</b>{" "}
                  {patientDetails?.Information?.gender
                    ? patientDetails?.Information?.gender
                    : messagenodata}
                </span>
                <span className="duration">
                  <b>Member since &nbsp;</b>
                </span>
                <span className="duration">
                  {" "}
                  {patientDetails?.Information?.sincefrom}
                </span>
              </div>
            </div>
            <div className="rpm-profile-container_row profile-other-infos">
              <RpmProfileReportsRowLayout>
                <div className="rpm-profile-grid-item item">
                  <div className="item-header">
                    <div className="icon">
                      <img src={Assets.profile} alt="rpm files" />
                      <b>Personal Info</b>
                    </div>
                    <div
                      className="edit-icon-container"
                      onClick={() => {
                        handleEditClick(
                          editOptions[0],
                          "input",
                          patientDetails?.Information?.fullname
                        );
                      }}
                    >
                      <EditRpmIcon />
                    </div>
                  </div>

                  <table className="item-table">
                    <tr>
                      <td>Blood Group</td>
                      <td>:</td>
                      {/* ****IMPORTANT Check the blood group from the API */}
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.bloodgroup
                          ? patientDetails?.Information?.bloodgroup
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Marital Status</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.maritalstatus
                          ? patientDetails?.Information?.maritalstatus
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>
                    <tr>
                      <td>Height</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.heightValue
                          ? patientDetails?.Information?.heightValue
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>
                    <tr>
                      <td>Weight</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.weightValue
                          ? patientDetails?.Information?.weightValue
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>BMI</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {bmi ? bmi.toFixed(2) : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>
                    <tr>
                      <td>Occupation</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.occupation
                          ? patientDetails?.Information?.occupation
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Email id</td>
                      <td>:</td>
                      {/* ****IMPORTANT display the data from patientdetails */}
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.emailid
                          ? patientDetails?.Information?.emailid
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Mobile Number</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.mobilenumber.length > 6
                          ? patientDetails?.Information?.mobilenumber.includes(
                              "+"
                            )
                            ? patientDetails?.Information?.mobilenumber
                            : "+" + patientDetails?.Information?.mobilenumber
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Nationality</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.nationality
                          ? patientDetails?.Information?.nationality
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>
                    <tr>
                      <td>National ID</td>
                      <td>:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        {patientDetails?.Information?.nationalId
                          ? patientDetails?.Information?.nationalId
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Address</td>
                      <td>:</td>
                      <td
                        style={{
                          paddingLeft: "10px",
                          textTransform: "capitalize",
                        }}
                      >
                        {patientDetails?.Information?.address1
                          ? address
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>
                  </table>
                </div>
                <div className="rpm-profile-grid-item item">
                  <div className="item-header">
                    <div className="icon">
                      <img src={Assets.friends} alt="rpm files" />
                      <b>Emergency Contact</b>
                    </div>

                    <div
                      className="edit-icon-container"
                      onClick={() => {
                        handleEditClick(
                          editOptions[2],
                          "input",
                          patientDetails?.Information?.fullname
                        );
                      }}
                    >
                      <EditRpmIcon />
                    </div>
                  </div>

                  <table className="item-table">
                    <tr>
                      <td>Name</td>
                      <td>:</td>
                      <td>
                        {patientDetails?.EmergencyContact?.name
                          ? patientDetails?.EmergencyContact?.name
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Relationship</td>
                      <td>:</td>
                      <td>
                        {patientDetails?.EmergencyContact?.relationship
                          ? patientDetails?.EmergencyContact?.relationship
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Mobile Number</td>
                      <td>:</td>
                      <td>
                        {patientDetails?.EmergencyContact?.phoneNumber
                          ? patientDetails?.EmergencyContact?.phoneNumber.includes(
                              "+"
                            )
                            ? patientDetails?.EmergencyContact?.phoneNumber
                            : "+" + patientDetails?.EmergencyContact?.phoneNumber
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Alternate Number</td>
                      <td>:</td>
                      <td>
                        {patientDetails?.EmergencyContact
                          ?.alternativephoneNumber &&
                        patientDetails?.EmergencyContact?.alternativephoneNumber
                          .length > 6
                          ? patientDetails?.EmergencyContact?.alternativephoneNumber.includes(
                              "+"
                            )
                            ? patientDetails?.EmergencyContact
                            ?.alternativephoneNumber
                            : "+" +
                              patientDetails?.EmergencyContact
                              ?.alternativephoneNumber
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>

                    <tr>
                      <td>Address</td>
                      <td>:</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {patientDetails?.EmergencyContact?.address1
                          ? emeraddress
                          : messagenodata}
                      </td>
                      <td style={{ paddingLeft: "10px" }}></td>
                    </tr>
                  </table>
                </div>
              </RpmProfileReportsRowLayout>
            </div>
          </div>

          <div className="rpm-profile-container_row profile-other-infos">
            <RpmOtherDetailsGridLayout>
              <div
                className="rpm-profile-grid-item item"
                style={{ display: "none" }}
              >
                <div className="item-header">
                  <div className="icon">
                    <img
                      className="doctor-image"
                      src={Assets.doctor}
                      alt="rpm files"
                    />
                    <b>Treating Doctor</b>
                  </div>

                  <div
                    className="edit-icon-container"
                    onClick={() => {
                      handleEditClick(
                        editOptions[1],
                        "input",
                        patientDetails?.Information?.fullname
                      );
                    }}
                  >
                    <EditRpmIcon />
                  </div>
                </div>

                <table className="item-table">
                  <tr>
                    <td>Treating Doctor/Physician</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.RegularDoctor?.name
                        ? patientDetails.RegularDoctor?.name
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Hospital Name</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.RegularDoctor?.practiceName
                        ? patientDetails?.RegularDoctor?.practiceName
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Contact Number</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.RegularDoctor?.phoneNumber &&
                      patientDetails.RegularDoctor.phoneNumber.length > 6
                        ? patientDetails.RegularDoctor.phoneNumber.includes("+")
                          ? patientDetails.RegularDoctor.phoneNumber
                          : "+" +
                            patientDetails.RegularDoctor.phoneNumber.trim()
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                </table>
              </div>

              <div className="rpm-profile-grid-item item">
                <div className="item-header">
                  <div className="icon">
                    <img src={Assets.insurance} alt="rpm files" />
                    <b>Insurance</b>
                  </div>

                  <div
                    className="edit-icon-container"
                    onClick={() => {
                      handleEditClick(
                        editOptions[3],
                        "input",
                        patientDetails?.Information?.fullname
                      );
                    }}
                  >
                    <EditRpmIcon />
                  </div>
                </div>

                <table className="item-table">
                  <tr>
                    <td>Provider Name</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.Insurance?.Company
                        ? patientDetails?.Insurance?.Company
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Member Number</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.Insurance?.MemberNumber
                        ? patientDetails?.Insurance?.MemberNumber
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>

                  <tr>
                    <td>Expiry Date</td>
                    <td>:</td>
                    <td>
                      {patientDetails?.Insurance?.ExpiryDate
                        ? patientDetails?.Insurance?.ExpiryDate
                        : messagenodata}
                    </td>
                    <td style={{ paddingLeft: "10px" }}></td>
                  </tr>
                </table>
              </div>
            </RpmOtherDetailsGridLayout>
          </div>
        </>
      )}

      <Modal
        title={`Edit ${editItem?.item}`}
        width={1000}
        closable={false}
        footer={null}
        maskClosable={false}
        open={isEditOpen}
        //onOk={handleEditOk}
        //onCancel={handleEditClose}
      >
        <div className="edit-profile-modal-container">
          <Form
            form={profileform}
            name="profileform"
            onFinish={handleEditOk}
            onFinishFailed={onFinishFailedVitals}
            autoComplete="off"
            preserve={false}
          >
            {editItem && editItem.item == editOptions[0] && (
              <>
                <div className="edit-profile-body">
                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Blood Group <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationbloodgroup"
                      rules={[
                        { required: true, message: "Select blood group " },
                      ]}
                      initialValue={patientDetails?.Information?.bloodgroup}
                    >
                      <Dropdown
                        //  value={patientDetails?.Information?.bloodgroup}
                        id="BloodGroup"
                        data={bloodGroups}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationbloodgroup",
                            value: e.value,
                          });
                        }}
                        placeholder="Select Blood Group"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Marital Status <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationmaritalstatus"
                      rules={[
                        { required: true, message: "Select marital status " },
                      ]}
                      initialValue={patientDetails?.Information?.maritalstatus}
                    >
                      <Dropdown
                        value={patientDetails?.Information?.maritalstatus}
                        id="MaritalStatus"
                        data={Marriagestatus}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationmaritalstatus",
                            value: e.value,
                          });
                        }}
                        placeholder="Select Marital Status"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Height (
                      <span style={{ textTransform: "lowercase" }}>in cm</span>){" "}
                      <MandaroryFlag />:
                    </span>
                    <Form.Item
                      name="InformationheightValue"
                      rules={[
                        { required: true, message: "Enter height  " },
                        {
                          max: 5,
                          message: "Value should be less than 5 character",
                        },
                      ]}
                      initialValue={
                        patientDetails.Information?.heightValue != null
                          ? patientDetails.Information?.heightValue.replace(
                              " cm",
                              ""
                            )
                          : ""
                      }
                    >
                      <Input
                        onKeyDown={allowOnlyunumber}
                        defaultValue={
                          patientDetails.Information?.heightValue != null
                            ? patientDetails.Information?.heightValue.replace(
                                " cm",
                                ""
                              )
                            : ""
                        }
                        id="Height"
                        maxLength={5}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "InformationheightValue",
                            value: e.target.value,
                          });
                        }}
                        placeholder="Enter Height"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Weight (
                      <span style={{ textTransform: "lowercase" }}>in kg</span>){" "}
                      <MandaroryFlag />:
                    </span>
                    <Form.Item
                      name="InformationweightValue"
                      rules={[
                        { required: true, message: "Enter weight" },

                        {
                          max: 5,
                          message: "Value should be less than 5 character",
                        },
                      ]}
                      initialValue={
                        patientDetails.Information?.weightValue != null
                          ? patientDetails.Information?.weightValue.replace(
                              " kg",
                              ""
                            )
                          : ""
                      }
                    >
                      <Input
                        onKeyDown={allowOnlyunumber}
                        defaultValue={
                          patientDetails.Information?.weightValue != null
                            ? patientDetails.Information?.weightValue.replace(
                                " kg",
                                ""
                              )
                            : ""
                        }
                        maxLength={5}
                        id="weight"
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "InformationweightValue",
                            value: e.target.value,
                          });
                        }}
                        placeholder="Enter Weight"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Occupation <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationoccupation"
                      rules={[
                        { required: true, message: "Enter Occupation  " },
                      ]}
                      initialValue={patientDetails?.Information?.occupation}
                    >
                      {/* <Dropdown
                                        value={patientDetails?.Information?.occupation}
                                        id="occupation"
                                        data={occupation}
                                        onChange={(e) => {
                                            handleEditInputChanges({ key: "Informationoccupation", value: e.value });
                                        }}
                                        placeholder="Select occupation"
                                    /> */}
                      <Input
                        defaultValue={patientDetails?.Information?.occupation}
                        maxLength={30}
                        id="Informationoccupation"
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationoccupation",
                            value: e.target.value,
                          });
                        }}
                        placeholder="Enter Occupation"
                      />
                    </Form.Item>
                  </div>

                  {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">Email id :</span>
                                    <Form.Item
                                    name="Informationoccupation"
                                    rules={[{ required: true, message: 'Please enter Height  ' }]}
                                    initialValue={patientDetails?.Information?.occupation}
                                    >
                                        <Input defaultValue={patientDetails?.Information?.emailid} id='Email' onChange={handleEditInputChange} placeholder="Type here" />
                                    </Form.Item>
                                </div> */}

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Mobile Number <MandaroryFlag /> :
                    </span>
                    {/* <Input id='Mobile'  defaultValue={patientDetails?.Information?.mobilenumber} onChange={handleEditInputChange} placeholder="Type here" />
                     */}

                    <Form.Item
                      name="Informationmobilenumber"
                      rules={[
                        { required: true, message: "Enter mobile number" },
                        {
                          min: 6,
                          message:
                            "The mobile number should be minimum 6 digits",
                        },
                      ]}
                      initialValue={patientDetails?.Information?.mobilenumber?.split(" ")[1]}
                    >
                      <CustomPhoneInputV2
                        placeholder="Enter mobile number"
                        defaultCountryCode={
                          patientDetails?.Information?.mobilenumber?.split(
                            " "
                          )[0]
                        }
                        defaultvalue={
                          patientDetails?.Information?.mobilenumber?.split(
                            " "
                          )[1]
                        }
                        onChange={(number, value, data) => {
                          console.log(data);
                          // handleEditInputNumberChange({ key: "Mobile", value: value })
                          handleEditInputChanges({
                            key: "Informationmobilenumber",
                            value: value,
                          });
                        }}
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Nationality <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationnationality"
                      rules={[
                        { required: true, message: "Enter nationality " },
                      ]}
                      initialValue={patientDetails?.Information?.nationality}
                    >
                      <Input
                        id="Nationality"
                        defaultValue={patientDetails?.Information?.nationality}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationnationality",
                            value: e.target.value,
                          });
                        }}
                        maxLength={25}
                        placeholder="Enter Nationality"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      National ID <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="InformationnationalId"
                      rules={[
                        { required: true, message: "Enter national id  " },
                        {
                          min: 9,
                          message: "National ID must contain 9 character",
                        },
                      ]}
                      initialValue={patientDetails?.Information?.nationalId}
                    >
                      <Input
                        type={accessCountry === "IN" ? "text" : "number"}
                        id="Nationality"
                        defaultValue={patientDetails?.Information?.nationalId}
                        maxLength={accessCountry === "IN" ? 12 : 9}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "InformationnationalId",
                            value: e.target.value,
                          });
                        }}
                        placeholder="Enter National ID"
                      />
                    </Form.Item>
                  </div>

                  {/* <div className="edit-profile-form-item">
                                    <span className="edit-profile-caption">Address :</span>
                                    <Input defaultValue={patientDetails?.Information?.currenctaddress} placeholder="Type here" />
                                </div> */}
                </div>

                <div className="edit-profile-body">
                  <div className="edit-profile-form-item ">
                    <span className="edit-profile-caption">
                      Address 1 <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationaddress1"
                      rules={[{ required: true, message: "Enter Address 1  " }]}
                      initialValue={patientDetails?.Information?.address1}
                    >
                      <TextArea
                        id="Address1"
                        defaultValue={patientDetails?.Information?.address1}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationaddress1",
                            value: e.target.value,
                          });
                        }}
                        rows={5}
                        placeholder="Enter Address 2"
                        maxLength={100}
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Address 2 (Optional) :
                    </span>
                    <Form.Item
                      name="Informationaddress2"
                      //  rules={[{ required: true, message: 'Enter  Address 2  ' }]}
                      initialValue={patientDetails?.Information?.address2}
                    >
                      <TextArea
                        id="Address2"
                        defaultValue={patientDetails?.Information?.address2}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationaddress2",
                            value: e.target.value,
                          });
                        }}
                        rows={5}
                        placeholder="Enter Address 2"
                        maxLength={100}
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item"></div>
                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      City <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationcity"
                      rules={[{ required: true, message: "Enter city" }]}
                      initialValue={patientDetails?.Information?.city}
                    >
                      <Input
                        id="City"
                        defaultValue={patientDetails?.Information?.city}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationcity",
                            value: e.target.value,
                          });
                        }}
                        maxLength={20}
                        placeholder="Enter City"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      State <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationstate"
                      rules={[{ required: true, message: "Enter state" }]}
                      initialValue={patientDetails?.Information?.state}
                    >
                      <Input
                        id="State"
                        defaultValue={patientDetails?.Information?.state}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationstate",
                            value: e.target.value,
                          });
                        }}
                        maxLength={20}
                        placeholder="Enter State"
                      />
                    </Form.Item>
                  </div>
                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">Country <MandaroryFlag />:</span>
                    <Form.Item
                      name="Informationcountry"
                      rules={[{ required: true, message: "Enter country" }]}
                      initialValue={patientDetails?.Information?.country}
                    >
                      <Input
                        defaultValue={patientDetails?.Information?.country}
                        id="Country"
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationcountry",
                            value: e.target.value,
                          });
                        }}
                        maxLength={20}
                        placeholder="Enter Country"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      PIN Code <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="InformationPIN"
                      rules={[
                        { required: true, message: "Enter PIN Code" },
                        {
                          max: 7,
                          message: "Value should be less than 7 character",
                        },
                        {
                          validator: (_, value) => {
                            if (/^[0-9]*$/.test(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Please enter only numeric values.");
                          },
                        }
                      ]}
                      initialValue={patientDetails?.Information?.PIN}
                    >
                      <Input
                        type="number"
                        maxLength={7}
                        id="PIN Code"
                        defaultValue={patientDetails?.Information?.PIN}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "InformationPIN",
                            value: e.target.value,
                          });
                        }}
                        placeholder="Enter PIN Code"
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Landmark (Optional):
                    </span>
                    <Form.Item
                      name="Informationlandmark"
                      initialValue={patientDetails?.Information?.landmark}
                    >
                      <Input
                        id="Landmark"
                        defaultValue={patientDetails?.Information?.landmark}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationlandmark",
                            value: e.target.value,
                          });
                        }}
                        maxLength={20}
                        placeholder="Enter Landmark"
                      />
                    </Form.Item>
                  </div>
                </div>
              </>
            )}

            {editItem && editItem.item == editOptions[1] && (
              <div className="edit-profile-body edit-profile-body-reg-dr">
                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Treating Doctor/Physician <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="RegularDoctorname"
                    rules={[
                      {
                        required: true,
                        message: "Enter treating doctor/physician name",
                      },
                    ]}
                    initialValue={patientDetails?.RegularDoctor?.name}
                  >
                    <Input
                      defaultValue={patientDetails?.RegularDoctor?.name}
                      id="RegularDoctorName"
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "RegularDoctorname",
                          value: e.target.value,
                        });
                      }}
                      maxLength={20}
                      placeholder="Enter Treating Doctor/Physician name"
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Hospital Name <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="RegularDoctorpracticeName"
                    rules={[{ required: true, message: "Enter hospital name" }]}
                    initialValue={patientDetails?.RegularDoctor?.practiceName}
                  >
                    <Input
                      defaultValue={patientDetails?.RegularDoctor?.practiceName}
                      id="RegularDoctorpracticeName"
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "RegularDoctorpracticeName",
                          value: e.target.value,
                        });
                      }}
                      maxLength={30}
                      placeholder="Enter Hospital Name"
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Contact Number <MandaroryFlag /> :
                  </span>
                  {/* <Input id='RegularDoctorContactNumber' onChange={(e) => { handleEditInputChanges({ key: "Informationcountry", value: e.target.value}) }} placeholder="Type here" /> */}
                  <Form.Item
                    name="RegularDoctorphoneNumber"
                    rules={[
                      { required: true, message: "Enter Contact Number" },

                      {
                        min: 6,
                        message: "The mobile number should be minimum 6 digits",
                      },
                    ]}
                    initialValue={patientDetails?.RegularDoctor?.phoneNumber}
                  >
                    <CustomPhoneInputV2
                      placeholder="Enter contact number"
                      defaultCountryCode={
                        patientDetails?.RegularDoctor?.phoneNumber
                          ?.trim()
                          .split(" ")[0]
                      }
                      defaultvalue={
                        patientDetails?.RegularDoctor?.phoneNumber
                          ?.trim()
                          .split(" ")[1]
                      }
                      onChange={(number, value, data) => {
                        // handleEditInputNumberChange({ key: "RegularDoctorContactNumber", value: value })
                        handleEditInputChanges({
                          key: "RegularDoctorphoneNumber",
                          value: value,
                        });
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
            )}
            {editItem && editItem.item == editOptions[2] && (
              <div className="edit-profile-body">
                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Contact Name <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="EmergencyContactname"
                    rules={[{ required: true, message: "Enter contact name " }]}
                    initialValue={patientDetails?.EmergencyContact?.name}
                  >
                    <Input
                      defaultValue={patientDetails?.EmergencyContact?.name}
                      id="EmergencyContactname"
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactname",
                          value: e.target.value,
                        });
                      }}
                      maxLength={20}
                      placeholder="Enter Contact Name"
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Relationship <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="EmergencyContactrelationship"
                    rules={[
                      { required: true, message: "Select relationship  " },
                    ]}
                    initialValue={
                      patientDetails?.EmergencyContact?.relationship
                    }
                  >
                    <Dropdown
                      defaultValue={
                        patientDetails?.EmergencyContact?.relationship
                      }
                      id="EmergencyContactrelationship"
                      data={relationship}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactrelationship",
                          value: e.value,
                        });
                      }}
                      placeholder="Select Relationship"
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Mobile Number <MandaroryFlag /> :
                  </span>
                  {/* <Input id='EmergencyContactNumber' onChange={(e) => { handleEditInputChanges({ key: "Informationcountry", value: e.target.value}) }} placeholder="Type here" /> */}
                  <Form.Item
                    name="EmergencyContactphoneNumber"
                    rules={[
                      { required: true, message: "Enter mobile number  " },

                      {
                        min: 6,
                        message: "The mobile number should be minimum 6 digits",
                      },
                    ]}
                    initialValue={patientDetails?.EmergencyContact?.phoneNumber}
                  >
                    <CustomPhoneInputV2
                      placeholder="Enter Mobile Number"
                      defaultCountryCode={
                        patientDetails?.EmergencyContact?.phoneNumber?.split(
                          " "
                        )[0]
                      }
                      defaultvalue={
                        patientDetails?.EmergencyContact?.phoneNumber?.split(
                          " "
                        )[1]
                      }
                      onChange={(number, value, data) => {
                        //andleEditInputNumberChange({ key: "EmergencyContactNumber", value: value })
                        handleEditInputChanges({
                          key: "EmergencyContactphoneNumber",
                          value: value,
                        });
                      }}
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Alternate Number :
                  </span>
                  {/* <Input id='EmergencyContactAlternateNumber' onChange={handleEditInputChange} placeholder="Type here" /> */}
                  <Form.Item
                    name="EmergencyContactalternativephoneNumber"
                    rules={[
                      {
                        min: 6,
                        message: "The mobile number should be minimum 6 digits",
                      },
                    ]}
                    initialValue={patientDetails?.EmergencyContact?.phoneNumber}
                  >
                    <CustomPhoneInputV2
                      placeholder="Enter Alternate Number"
                      defaultCountryCode={
                        patientDetails?.EmergencyContact?.alternativephoneNumber?.split(
                          " "
                        )[0]
                      }
                      defaultvalue={
                        patientDetails?.EmergencyContact?.alternativephoneNumber?.split(
                          " "
                        )[1]
                      }
                      onChange={(number, value, data) => {
                        handleEditInputChanges({
                          key: "EmergencyContactalternativephoneNumber",
                          value: value,
                        });
                      }}
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item ">
                  <span className="edit-profile-caption">
                    Address 1 <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="EmergencyContactaddress1"
                    rules={[{ required: true, message: "Enter Address 1 " }]}
                    initialValue={patientDetails?.EmergencyContact?.address1}
                  >
                    <TextArea
                      id="Address1"
                      defaultValue={patientDetails?.EmergencyContact?.address1}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactaddress1",
                          value: e.target.value,
                        });
                      }}
                      rows={5}
                      placeholder="Enter Address 1"
                      maxLength={100}
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Address 2 (Optional) :
                  </span>
                  <Form.Item
                    name="EmergencyContactaddress2"
                    // rules={[{ required: true, message: 'Enter Address 2' }]}
                    initialValue={patientDetails?.EmergencyContact?.address2}
                  >
                    <TextArea
                      id="Address2"
                      defaultValue={patientDetails?.EmergencyContact?.address2}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactaddress2",
                          value: e.target.value,
                        });
                      }}
                      rows={5}
                      placeholder="Enter Address 2"
                      maxLength={100}
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    City <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="EmergencyContactcity"
                    rules={[{ required: true, message: "Enter city" }]}
                    initialValue={patientDetails?.EmergencyContact?.city}
                  >
                    <Input
                      id="City"
                      defaultValue={patientDetails?.EmergencyContact?.city}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactcity",
                          value: e.target.value,
                        });
                      }}
                      maxLength={20}
                      placeholder="Enter City"
                    />
                  </Form.Item>
                </div>
                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">State <MandaroryFlag />:</span>
                  <Form.Item
                    name="EmergencyContactstate"
                    rules={[{ required: true, message: "Enter state" }]}
                    initialValue={patientDetails?.EmergencyContact?.state}
                  >
                    <Input
                      id="State"
                      defaultValue={patientDetails?.EmergencyContact?.state}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactstate",
                          value: e.target.value,
                        });
                      }}
                      maxLength={20}
                      placeholder="Enter State"
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Country <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="EmergencyContactcountry"
                    rules={[{ required: true, message: "Enter Country" }]}
                    initialValue={patientDetails?.EmergencyContact?.country}
                  >
                    <Input
                      defaultValue={patientDetails?.EmergencyContact?.country}
                      id="Country"
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactcountry",
                          value: e.target.value,
                        });
                      }}
                      maxLength={20}
                      placeholder="Enter Country"
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    PIN Code <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="EmergencyContactPIN"
                    rules={[{ required: true, message: "Enter PIN Code " }]}
                    initialValue={patientDetails?.EmergencyContact?.PIN}
                  >
                    <Input
                      type="number"
                      id="PIN Code"
                      defaultValue={patientDetails?.EmergencyContact?.PIN}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactPIN",
                          value: e.target.value,
                        });
                      }}
                      placeholder="Enter PIN Code"
                      maxLength={7}
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Landmark (Optional):
                  </span>
                  <Form.Item
                    name="EmergencyContactlandmark"
                    initialValue={patientDetails?.EmergencyContact?.landmark}
                  >
                    <Input
                      id="Landmark"
                      defaultValue={patientDetails?.EmergencyContact?.landmark}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "EmergencyContactlandmark",
                          value: e.target.value,
                        });
                      }}
                      maxLength={100}
                      placeholder="Enter Landmark"
                    />
                  </Form.Item>
                </div>
              </div>
            )}
            {editItem && editItem.item == editOptions[3] && (
              <div className="edit-profile-body">
                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Provider Name <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="InsuranceCompany"
                    rules={[
                      { required: true, message: "Select provider name" },
                    ]}
                    initialValue={patientDetails?.Insurance?.Company}
                  >
                    <Dropdown
                      defaultValue={patientDetails?.Insurance?.Company}
                      id="InsuranceCompany"
                      data={Insuranceproviders}
                      // onChange={handleEditSelectChange}
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "InsuranceCompany",
                          value: e.value,
                        });
                      }}
                      placeholder="Select Provider Name"
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Member Number <MandaroryFlag /> :
                  </span>
                  <Form.Item
                    name="InsuranceMemberNumber"
                    rules={[{ required: true, message: "Enter member number" }]}
                    initialValue={patientDetails?.Insurance?.MemberNumber}
                  >
                    <Input
                      defaultValue={patientDetails?.Insurance?.MemberNumber}
                      id="InsuranceMemberNumber"
                      onChange={(e) => {
                        handleEditInputChanges({
                          key: "InsuranceMemberNumber",
                          value: e.target.value,
                        });
                      }}
                      placeholder="Enter Member Number"
                      maxLength={50}
                    />
                  </Form.Item>
                </div>

                <div className="edit-profile-form-item">
                  <span className="edit-profile-caption">
                    Expiry Date <MandaroryFlag /> :
                  </span>
                  {/* <Input id='InsuranceExpiryDate' onChange={handleEditInputChange} placeholder="Type here" /> */}
                  <Form.Item
                    name="InsuranceExpiryDate"
                    rules={[{ required: true, message: "Select expiry date" }]}
                    initialValue={
                      patientDetails?.Insurance?.ExpiryDate
                        ? moment(patientDetails?.Insurance?.ExpiryDate)
                        : ""
                    }
                  >
                    <DatePicker
                      defaultValue={
                        patientDetails?.Insurance?.ExpiryDate
                          ? moment(patientDetails?.Insurance?.ExpiryDate)
                          : ""
                      }
                      className="input-date"
                      style={{ width: "100% !important" }}
                      format="DD/MMM/YYYY"
                      placeholder="DD-MM-YYYY"
                      allowClear={false}
                      onChange={(date_moment, value) => {
                        handleEditInputChanges({
                          key: "InsuranceExpiryDate",
                          value: value,
                        });
                      }}
                      disabledDate={(current) => {
                        return current < moment().subtract(1, "day");
                      }}
                      // disabledDate={(current) => {
                      //     return current < moment().subtract(1, 'day');
                      // }}
                      // onSelect={getTimeSlots}
                      // onChange={(e) => { setSelectedDate(convertDateToString(e)); getTimeSlots(e) }}
                      // defaultValue={moment(new Date())}
                    />
                  </Form.Item>
                </div>
              </div>
            )}
            {editItem && editItem.item == editOptions[4] && (
              <div className="edit-profile-bodys">
                {/* 
                        <div className="Profileimage">
                            <div className="edit-profile">
                            <img src={patientDetails?.Information?.profileImage ? patientDetails?.Information?.profileImage : "https://www.connect2mydoctor.com/assets/img/doctor-avatar.jpg"} alt="user image" />
                            <span>change</span>  
                            </div>
                        </div> */}

                <div className="edit-profile-body">
                  {/* <div className="edit-profile-form-item">
                                <span className="edit-profile-caption">Name :</span>
                                <Form.Item
                                    name="Informationfullname"
                                    rules={[{ required: true, message: 'Please enter full name' }]}
                                    initialValue={patientDetails?.Information?.fullname}

                                >
                                         <Input id='ProfileName' defaultValue={patientDetails?.Information?.fullname}  onChange={(e) => { handleEditInputChanges({ key: "Informationfullname", value: e.target.value, type:"EmergencyContact"}) }}  placeholder="Type here" />
                           

                                </Form.Item>
                            </div> */}

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Date of birth <MandaroryFlag /> :{" "}
                    </span>
                    {/* <Input defaultValue={patientDetails?.Information?.dob} id='ProfileAge' onChange={(e) => { handleEditInputChanges({ key: "Informationdob", value: e.target.value, type:"EmergencyContact"}) }} placeholder="Type here" />
                     */}
                    <Form.Item
                      name="Informationdob"
                      rules={[
                        {
                          required: true,
                          message: "Please select Date of birth ",
                        },
                      ]}
                      initialValue={
                        formData?.Informationdob
                          ? moment(formData?.Informationdob)
                          : ""
                      }
                    >
                      <DatePicker
                        defaultValue={
                          formData?.Informationdob
                            ? moment(formData?.Informationdob)
                            : ""
                        }
                        className="input-date"
                        style={{ width: "100% !important" }}
                        maxDate={moment().toDate()}
                        format="DD/MMM/YYYY"
                        placeholder="DD/MMM/YYYY"
                        disabledDate={(current) => {
                          return current > moment().subtract(1, "day");
                        }}
                        allowClear={false}
                        onChange={(date_moment, value) => {
                          handleEditInputChanges({
                            key: "Informationdob",
                            value: value,
                          });
                        }}
                      />
                    </Form.Item>
                  </div>

                  <div className="edit-profile-form-item">
                    <span className="edit-profile-caption">
                      Gender <MandaroryFlag /> :
                    </span>
                    <Form.Item
                      name="Informationgender"
                      rules={[
                        { required: true, message: "Please select  gender " },
                      ]}
                      initialValue={patientDetails?.Information?.gender}
                    >
                      {/* <Radio.Group name={gender} value={gender} onChange={(e) => { handleEditInputChanges({ key: "Informationgender", value: e.target.value }) }}>

                                        <Radio value={"Male"}>Male</Radio>

                                        <Radio value={"Female"}>Female</Radio>

                                        <Radio value={"Other"}>Other</Radio>

                                        </Radio.Group> */}
                      <Dropdown
                        value={patientDetails?.Information?.gender}
                        id="ProfileGender"
                        data={gender}
                        // onChange={handleEditInputChanges}
                        onChange={(e) => {
                          handleEditInputChanges({
                            key: "Informationgender",
                            value: e.value,
                          });
                        }}
                        placeholder="Select Gender"
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
            )}

            <div className="edit-profile-footer">
              <a className="edit-modal-footer-button" onClick={handleEditClose}>
                Close
              </a>
              <button
                type="submit"
                className="edit-modal-footer-button edit-modal-footer-button-save"
              >
                Save
              </button>
            </div>
          </Form>
        </div>
      </Modal>

      <Modal
        title="Package Reject"
        width={500}
        closable={false}
        footer={null}
        maskClosable={false}
        open={isrejectOpen}
        //onOk={handleEditOk}
        //onCancel={handleEditClose}
      >
        <div className="edit-profile-modal-container rejectpackage">
          <div className="edit-profile-body">
            <div className="edit-profile-form-item">
              <span className="edit-profile-caption">
                Reason for Reject <MandaroryFlag />
              </span>
              <Form.Item
                name="Informationreason"
                rules={[
                  {
                    required: true,
                    message: "Please select  Reason for Reject ",
                  },
                ]}
                initialValue={rejectionreason != "" ? rejectionreason : ""}
              >
                <Dropdown
                  value={rejectionreason != "" ? rejectionreason : ""}
                  id="Informationreason"
                  data={reasonforrejection}
                  // onChange={handleEditInputChanges}
                  onChange={(e) => {
                    setrejectionreason(e.value);
                  }}
                  placeholder="Select Reason"
                />
              </Form.Item>
            </div>
          </div>
          <div className="edit-profile-footer">
            <button
              type="button"
              className="edit-modal-footer-button"
              onClick={handlerectClose}
            >
              Close
            </button>
            <button
              className="edit-modal-footer-button edit-modal-footer-button-save"
              onClick={() => {
                Rejectsubscription(
                  "Reject",
                  packageDetails?.packagerequestId
                    ? packageDetails.packagerequestId
                    : ""
                );
              }}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>

      <SuccessModal
        state={isacceptOpen}
        setState={setisacceptOpen}
        successMessage={successMessage}
      />
    </div>
  );
}

export default RpmProfile;

const MandaroryFlag = () => <span className="mandatory">*</span>;
